let www = 'https://www.'
// edit all links here globally
export const  links = {
    behance:www+'behance.net/favouroyindam',
    linkedin:www+'linkedin.com/in/favour-oyindamola-awosise-b4ba201a5',
    twitter:www+'twitter.com/design_mogul_',
    email:'mailto:oyindamolafavour2017@gmail.com',
    works:'#projects',
    resume:'https://docs.google.com/file/d/14qvqA8YPRjgWow5YX5ZVtVovjFXPaAD7/edit?usp=docslist_api&filetype=msword'
}